import type { ComponentProps } from 'react'
import { type ControlSize, type ControlVariant, controlClassName } from '../lib/control-styles'
import { useFieldControlProps } from '../lib/field-context'
export function Input({
  className,
  variant = 'outline',
  controlSize = 'md',
  ...props
}: ComponentProps<'input'> & { variant?: ControlVariant; controlSize?: ControlSize }) {
  const field = useFieldControlProps(props)
  return (
    <input
      {...props}
      {...field}
      data-slot="input"
      className={controlClassName(variant, className, controlSize)}
    />
  )
}
